var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"kim",style:(("\n    background-image: url(" + (require('@/assets/kim/kim-'+ _vm.mood + '.svg')) + ");\n    background-color: " + _vm.color + ";\n    background-position: " + _vm.returnPosition))})}
var staticRenderFns = []

export { render, staticRenderFns }